"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnknownExceptionMessage = exports.UnknownExceptionCode = exports.MainMethodType = exports.ResultCode = void 0;
var ResultCode;
(function (ResultCode) {
    ResultCode["Succeeded"] = "succeeded";
    ResultCode["Failed"] = "failed";
    ResultCode["Canceled"] = "canceled";
})(ResultCode = exports.ResultCode || (exports.ResultCode = {}));
var MainMethodType;
(function (MainMethodType) {
    MainMethodType["VNPayGatewayQR"] = "VNPayGatewayQR";
    MainMethodType["COD"] = "COD";
    MainMethodType["QRCodeMMS"] = "QRCodeMMS";
    MainMethodType["SPOSCard"] = "SPOSCard";
    MainMethodType["EWallet"] = "EWallet";
    MainMethodType["QRCodeCustomer"] = "QRCodeCustomer";
    MainMethodType["MoMoAIO"] = "MoMoAIO";
    MainMethodType["Cash"] = "Cash";
    MainMethodType["BankTransfer"] = "BankTransfer";
    MainMethodType["Installment"] = "Installment";
    MainMethodType["All"] = "All";
    MainMethodType["MoMoQROffline"] = "MoMoQROffline";
    MainMethodType["VNPayGatewayCreditCard"] = "VNPayGatewayCreditCard";
    MainMethodType["VNPayGatewayATMBank"] = "VNPayGatewayATMBank";
    MainMethodType["VNPayGatewayMobileBanking"] = "VNPayGatewayMobileBanking";
})(MainMethodType = exports.MainMethodType || (exports.MainMethodType = {}));
exports.UnknownExceptionCode = 'UnknownException';
exports.UnknownExceptionMessage = 'Unexpected error occurred!';
